import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-drawer-content',
  imports: [],
  templateUrl: './drawer-content.component.html',
  styleUrl: './drawer-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DrawerContentComponent {}
